import React, { useState } from "react";
import CircularBar from "../components/CircularBar";
import { FaRupeeSign } from "react-icons/fa";
import { useSelector } from "react-redux";

const Profile = () => {
  const { user } = useSelector((state) => state.user);
  const [tabIndex, setTabIndex] = useState(1);
  return (
    <>
      <div className="home-flex">
        <div className="home-right">
          <div className="tabs-overflow">
            <ul className="home-tabs">
              <li
                className={tabIndex === 1 ? "active" : ""}
                onClick={() => setTabIndex(1)}
              >
                Personal details
              </li>
              <li
                className={tabIndex === 2 ? "active" : ""}
                onClick={() => setTabIndex(2)}
              >
                Finance details
              </li>
              <li
                className={tabIndex === 3 ? "active" : ""}
                onClick={() => setTabIndex(3)}
              >
                Plan details
              </li>
              <li
                className={tabIndex === 4 ? "active" : ""}
                onClick={() => setTabIndex(4)}
              >
                Account details
              </li>
            </ul>
          </div>

          <hr />

          {tabIndex === 1 && (
            <div className="home-tab">
              <div>
                <p>Name</p>
                <p className="fw-bold">{user.Full_Name || "-"}</p>
              </div>
              <div>
                <p>Phone number</p>
                <p className="fw-bold">{user.Phone || "-"}</p>
              </div>
              <div className="profile-email-div">
                <p>Email address</p>
                <p className="fw-bold">{user.Email || "-"}</p>
              </div>
              <div>
                <p>Date of birth</p>
                <p className="fw-bold">
                  {user.Date_Of_Birth?.split("-").reverse().join("-") || "-"}
                </p>
              </div>
              <div className="address">
                <p>Address</p>
                <p className="fw-bold">{user.Flat_Building_No || "-"}</p>
              </div>
              <div>
                <p>PIN code</p>
                <p className="fw-bold">{user.Zip_Code || "-"}</p>
              </div>
              <div>
                <p>City</p>
                <p className="fw-bold">{user.City || "-"}</p>
              </div>
              <div>
                <p>State</p>
                <p className="fw-bold">{user.States || "-"}</p>
              </div>
            </div>
          )}

          {tabIndex === 2 && (
            <div className="home-tab">
              <div>
                <p>App loan</p>
                <p className="fw-bold">
                  {user.App_Loan_Debt !== "" && <FaRupeeSign />}
                  {user.App_Loan_Debt || "-"}
                </p>
              </div>
              <div>
                <p>Personal loan</p>
                <p className="fw-bold">
                  {user.Personal_Loan_Debt !== "" && <FaRupeeSign />}
                  {user.Personal_Loan_Debt || "-"}
                </p>
              </div>
              <div>
                <p>Credit card debt</p>
                <p className="fw-bold">
                  {user.Credit_Card_Debt !== "" && <FaRupeeSign />}
                  {user.Credit_Card_Debt || "-"}
                </p>
              </div>
              <div>
                <p>Total outstanding amount</p>
                <p className="fw-bold">
                  {user.Total_OS_Amount !== "" && <FaRupeeSign />}
                  {user.Total_OS_Amount || "-"}
                </p>
              </div>
              <div>
                <p>Income</p>
                <p className="fw-bold">
                  {user.Total_monthly_income !== "" && <FaRupeeSign />}
                  {user.Total_monthly_income || "-"}
                </p>
              </div>
              <div>
                <p>Expense</p>
                <p className="fw-bold">
                  {user.Total_of_living_expenses !== "" && <FaRupeeSign />}
                  {user.Total_of_living_expenses || "-"}
                </p>
              </div>
              <div>
                <p>Dispossible income</p>
                <p className="fw-bold">
                  {user.Disposable_Income_DI !== "" && <FaRupeeSign />}
                  {user.Disposable_Income_DI || "-"}
                </p>
              </div>
              <div className="di-percent-flex">
                <p>DI percentage</p>
                <CircularBar percent={parseFloat(user.DI)} />
              </div>
            </div>
          )}

          {tabIndex === 3 && (
            <div className="home-tab">
              <div>
                <p>Subscription Period</p>
                <p className="fw-bold">
                  {`${user.Choose_your_Debt_Free_Plan_DFP} months`}
                </p>
              </div>
              <div>
                <p>SML EMI</p>
                <p className="fw-bold">
                  {user.SML_EMI !== "" && <FaRupeeSign />}
                  {user.SML_EMI || "-"}
                </p>
              </div>
              <div>
                <p>Subscription fee</p>
                <p className="fw-bold">
                  {user.Subscription_Fees !== "" && <FaRupeeSign />}
                  {user.Subscription_Fees || "-"}
                </p>
              </div>
              <div>
                <p>Final Amount</p>
                <p className="fw-bold">
                  {user.Total_SML_EMI !== "" && <FaRupeeSign />}
                  {user.Total_SML_EMI || "-"}
                </p>
              </div>
              <div>
                <p>Amount paid</p>
                <p className="fw-bold">
                  {user.Payment_Amount !== "" && <FaRupeeSign />}
                  {user.Payment_Amount || "-"}
                </p>
              </div>

              <div>
                <p>Payment date</p>
                <p className="fw-bold">
                  {user.Payment_Date.split("-").reverse().join("-") || "-"}
                </p>
              </div>
            </div>
          )}

          {tabIndex === 4 && (
            <div className="home-tab">
              <div>
                <p>Account status</p>
                <p className="fw-bold">{user.Account_Status || "-"}</p>
              </div>
              <div>
                <p>Reference number</p>
                <p className="fw-bold">{user.Reference_Number || "-"}</p>
              </div>
              <div>
                <p>Source</p>
                <p className="fw-bold">{user.Sources || "-"}</p>
              </div>
              <div>
                <p>Account ID</p>
                <p className="fw-bold">{user.id || "-"}</p>
              </div>
              <div>
                <p>Transaction number</p>
                <p className="fw-bold">
                  {user.Transaction_Reference_No || "-"}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Profile;
